import type { ChakraProps } from "@chakra-ui/react";
import type { MenuExtendedProps } from "config/menus/menus.d";
import MenuLink from "modules/common/components/MenuLink";

export const SubmenuContent = ({ submenu, ...props }: { submenu: MenuExtendedProps["subMenu"] } & ChakraProps) => (
  <>
    {submenu.map((item) => (
      <MenuLink
        menuItem={item}
        color="greyscale.600"
        textDecoration={item.active ? "underline" : "none"}
        textUnderlineOffset="4px"
        key={item.label}
        mb={4}
        rounded="md"
        display="block"
        _visited={{}}
        _hover={{ color: "primary.500" }}
        {...props}
      />
    ))}
  </>
);
